import i18n from '@/i18n/i18n'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

export const RETURNS_ROUTE = 'returns'
export const RETURNS_LIST_ROUTE = 'returns.list'
export const RETURN_DETAILS_ROUTE = 'returns.detail'
export const RETURN_MANUAL_FORM = 'returns.new'
export const RETURNS_EXPORT = 'returns.export'
export const RETURN_PREFILL_FORM = 'returns.prefilled'

const newReturnFormBtn = {
  title: () => i18n.t('New return'),
  icon: faPlus,
  mode: 'secondary',
  name: RETURN_MANUAL_FORM,
}

export default [
  {
    name: RETURNS_ROUTE,
    path: '/returns/',
    redirect: { name: RETURNS_LIST_ROUTE, query: { state: 'incoming' } },
    component: () => import('@/app/returns/views/ReturnsListView.vue'),
    meta: {
      pageTitle: () => i18n.t('Returns'),
      permissions: ['manage_returns'],
      buttons: [newReturnFormBtn],
    },
  },
  {
    name: RETURNS_LIST_ROUTE,
    path: '/returns/list',
    component: () => import('@/app/returns/views/ReturnsListView.vue'),
    props: (route) => {
      return {
        currentState: route.query.state,
        searchQuery: route.query.search,
        page: route.query.page,
        pageSize: route.query.page_size,
        parcelStatus: Number.parseInt(route.query.parcel_status) || undefined,
        currentParcelStatus: Number.parseInt(route.query.parcel_status) || undefined,
        currentReturnStatus: route.query.return_status,
      }
    },
    meta: {
      pageTitle: () => i18n.t('Returns'),
      permissions: ['manage_returns'],
      buttons: [newReturnFormBtn],
    },
  },
  {
    name: RETURN_PREFILL_FORM,
    path: '/returns/prefilled/:parcelId',
    component: () => import('@/app/returns/views/PrefilledReturn.vue'),
    props: route => ({
      parcelId: Number.parseInt(route.params.parcelId),
      direction: route.query.direction || undefined,
    }),
    meta: {
      pageTitle: () => i18n.t('Create new return'),
      permissions: ['manage_returns'],
    },
  },

  {
    name: RETURN_MANUAL_FORM,
    path: '/returns/new/',
    component: () => import('@/app/returns/views/NewReturn.vue'),
    meta: {
      pageTitle: () => i18n.t('Create new return'),
      permissions: ['manage_returns'],
    },
  },

  {
    name: RETURNS_EXPORT,
    path: '/returns/export/',
    component: () => import('@/app/returns/views/ReturnsExport.vue'),
    meta: {
      pageTitle: () => i18n.t('Export returns'),
      permissions: ['manage_returns'],
    },
  },

  {
    name: RETURN_DETAILS_ROUTE,
    path: '/returns/:returnShipmentId',
    component: () => import('@/app/returns/components/ReturnDetails.vue'),
    props: route => ({
      returnShipmentId: parseInt(route.params.returnShipmentId),
    }),
    meta: {
      pageTitle: () => i18n.t('Returns'),
      permissions: ['manage_returns'],
    },
  },
]
